export interface Chapter {
  id: string;
  number: number;
  title: string;
  createdAt: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  categories: string[];
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: Chapter[];
  updatedAt: string;
  createdAt: string;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
}

export const categories: Category[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'school', name: '校园', icon: 'ri-building-line' },
  { slug: 'mystery', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'bl', name: 'BL', icon: 'ri-men-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
];

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'secretarys-escape',
    title: '秘书的逃脱',
    author: '金作家 / 李画师',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20female%20office%20worker%20in%20a%20modern%20cityscape%2C%20romance%20drama%20vibe%2C%20soft%20warm%20lighting%2C%20clean%20background%2C%20elegant%20character%20design%2C%20digital%20art%20style%2C%20muted%20warm%20tones&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '职场女强人遭遇背叛后，她决定不再隐忍。一场精心策划的逃脱计划悄然展开，而她不知道的是，公司那位冷酷总裁早已看穿一切...一段关于复仇与爱情的精彩韩漫故事。',
    categories: ['romance', 'drama'],
    tags: ['职场', '复仇', '总裁', '女强人'],
    status: '连载中',
    rating: 9.5,
    views: 1280000,
    chapters: Array.from({ length: 67 }, (_, i) => ({
      id: `ch1-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: `2026-${String(Math.max(1, Math.ceil((67 - i) / 4))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-04',
    createdAt: '2025-02-15',
  },
  {
    id: '2',
    slug: 'magic-academy-king',
    title: '魔法学院之王',
    author: '韩流工作室',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20male%20student%20with%20magical%20powers%20in%20a%20fantasy%20academy%20setting%2C%20magical%20effects%2C%20floating%20spells%2C%20dramatic%20lighting%2C%20clean%20warm%20background%2C%20action%20fantasy%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '平凡高中生意外觉醒魔法天赋，被邀请进入神秘的魔法学院。在这里，弱肉强食是唯一法则，而他誓要成为学院最强的王者！精彩的校园奇幻冒险故事。',
    categories: ['fantasy', 'action', 'school'],
    tags: ['魔法', '学院', '战斗', '成长'],
    status: '连载中',
    rating: 9.3,
    views: 960000,
    chapters: Array.from({ length: 52 }, (_, i) => ({
      id: `ch2-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: `2026-${String(Math.max(1, Math.ceil((52 - i) / 4))).padStart(2, '0')}-${String((i % 25) + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-03',
    createdAt: '2025-05-20',
  },
  {
    id: '3',
    slug: 'sweet-trap',
    title: '甜蜜陷阱',
    author: '崔作家',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20couple%20in%20a%20cafe%20setting%2C%20warm%20pastel%20tones%2C%20cozy%20atmosphere%2C%20gentle%20expressions%2C%20romantic%20comedy%20vibe%2C%20clean%20simple%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '咖啡店兼职生遇到了每天准时来喝美式的神秘男子。她以为只是普通邂逅，却不知道自己是对方精心安排的猎物。一场甜蜜又危险的恋爱游戏即将开始...',
    categories: ['romance', 'comedy'],
    tags: ['咖啡店', '都市', '甜宠', '神秘'],
    status: '连载中',
    rating: 9.1,
    views: 850000,
    chapters: Array.from({ length: 45 }, (_, i) => ({
      id: `ch3-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: `2026-${String(Math.max(1, Math.ceil((45 - i) / 3))).padStart(2, '0')}-${String((i % 20) + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-02',
    createdAt: '2025-08-10',
  },
  {
    id: '4',
    slug: 'shadow-detective',
    title: '暗影侦探',
    author: '朴作家 / 金工作室',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20detective%20in%20a%20dark%20alley%2C%20mystery%20noir%20atmosphere%2C%20trench%20coat%2C%20dramatic%20shadows%2C%20cinematic%20lighting%2C%20clean%20composition%2C%20suspense%20thriller%20vibe&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '一位拥有超强推理能力的前刑警，在追查一连串离奇案件时，发现所有线索都指向一个神秘组织。真相远比想象中更加黑暗...紧张刺激的悬疑推理韩漫。',
    categories: ['mystery', 'drama'],
    tags: ['推理', '犯罪', '悬疑', '暗黑'],
    status: '已完结',
    rating: 9.6,
    views: 1560000,
    chapters: Array.from({ length: 80 }, (_, i) => ({
      id: `ch4-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: `2025-${String(Math.max(1, Math.ceil((80 - i) / 5))).padStart(2, '0')}-${String((i % 15) + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-06-15',
    createdAt: '2024-03-01',
  },
  {
    id: '5',
    slug: 'rebirth-of-villainess',
    title: '反派千金的重生',
    author: '韩漫工坊',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20noblewoman%20in%20a%20European%20style%20palace%20setting%2C%20fantasy%20romance%2C%20elegant%20dress%2C%20dramatic%20expression%2C%20warm%20golden%20lighting%2C%20clean%20composition&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '被陷害致死的公爵千金意外重生回到三年前。这一次，她不会再做任人摆布的棋子。她要让所有背叛她的人付出代价，同时改写自己的命运！',
    categories: ['fantasy', 'romance', 'drama'],
    tags: ['重生', '贵族', '复仇', '逆袭'],
    status: '连载中',
    rating: 9.7,
    views: 2100000,
    chapters: Array.from({ length: 91 }, (_, i) => ({
      id: `ch5-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: `2026-${String(Math.max(1, Math.ceil((91 - i) / 5))).padStart(2, '0')}-${String((i % 30) + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-05',
    createdAt: '2024-10-01',
  },
  {
    id: '6',
    slug: 'campus-idol-secret',
    title: '校园偶像的秘密',
    author: '首尔漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20handsome%20male%20idol%20trainee%20in%20a%20school%20uniform%2C%20youthful%20vibrant%20energy%2C%20clean%20bright%20background%2C%20pop%20culture%20aesthetic%2C%20modern%20Korean%20art%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '校园里最受欢迎的练习生偶像，私下里却有一个不为人知的秘密。当这个秘密被同班同学意外发现后，一段关于梦想、友情和初恋的故事就此展开。',
    categories: ['school', 'romance', 'comedy'],
    tags: ['偶像', '校园', '秘密', '青春'],
    status: '连载中',
    rating: 8.9,
    views: 720000,
    chapters: Array.from({ length: 38 }, (_, i) => ({
      id: `ch6-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: `2026-${String(Math.max(1, Math.ceil((38 - i) / 3))).padStart(2, '0')}-${String((i % 18) + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-01',
    createdAt: '2025-12-05',
  },
  {
    id: '7',
    slug: 'ghost-apartment',
    title: '幽灵公寓',
    author: '恐怖工厂',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20horror%20cover%20illustration%20of%20an%20eerie%20apartment%20building%20at%20night%2C%20supernatural%20elements%2C%20ghostly%20figures%2C%20dark%20atmospheric%20lighting%2C%20creepy%20vibe%2C%20clean%20composition%2C%20thriller%20style&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '搬进首尔某老旧公寓的年轻人，每晚都听到隔壁传来诡异的声响。当他终于鼓起勇气敲开那扇门后，等待他的是一系列令人毛骨悚然的超自然事件...',
    categories: ['horror', 'mystery'],
    tags: ['恐怖', '幽灵', '超自然', '公寓'],
    status: '已完结',
    rating: 9.2,
    views: 1100000,
    chapters: Array.from({ length: 60 }, (_, i) => ({
      id: `ch7-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: `2025-${String(Math.max(1, Math.ceil((60 - i) / 4))).padStart(2, '0')}-${String((i % 12) + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-05-20',
    createdAt: '2024-06-15',
  },
  {
    id: '8',
    slug: 'bl-flower-shop',
    title: '花店老板的心事',
    author: '春日漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20BL%20genre%20cover%20illustration%20of%20a%20florist%20in%20a%20beautiful%20flower%20shop%2C%20warm%20gentle%20lighting%2C%20romantic%20atmosphere%2C%20soft%20pastel%20colors%2C%20clean%20composition%2C%20emotional%20art%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '在江南区经营小花店的老板，每天都会收到一束匿名的花。追踪送花人的过程中，他逐渐被卷入一段意想不到的甜蜜恋情。温馨治愈的BL佳作。',
    categories: ['bl', 'romance'],
    tags: ['花店', '都市', '治愈', '甜蜜'],
    status: '连载中',
    rating: 9.4,
    views: 980000,
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: `ch8-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: `2026-${String(Math.max(1, Math.ceil((42 - i) / 3))).padStart(2, '0')}-${String((i % 22) + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-04',
    createdAt: '2025-09-18',
  },
  {
    id: '9',
    slug: 'laugh-king',
    title: '笑傲江湖之搞笑王',
    author: '欢乐制作',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20comedy%20cover%20illustration%20with%20exaggerated%20funny%20expressions%2C%20colorful%20vibrant%20style%2C%20comedic%20martial%20arts%20theme%2C%20clean%20bright%20background%2C%20humorous%20cartoon%20aesthetic&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '一个意外获得搞笑超能力的普通上班族，用笑声征服武林的故事。从办公室到江湖，他的搞笑之路无人能挡！全程高能笑点不断的欢乐韩漫。',
    categories: ['comedy', 'action'],
    tags: ['搞笑', '武侠', '超能力', '欢乐'],
    status: '连载中',
    rating: 9.0,
    views: 680000,
    chapters: Array.from({ length: 35 }, (_, i) => ({
      id: `ch9-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: `2026-${String(Math.max(1, Math.ceil((35 - i) / 2))).padStart(2, '0')}-${String((i % 17) + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-03',
    createdAt: '2026-01-10',
  },
  {
    id: '10',
    slug: 'family-drama',
    title: '家族风云',
    author: '经典工作室',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20drama%20cover%20illustration%20of%20a%20family%20gathering%20in%20a%20traditional%20Korean%20house%2C%20emotional%20dramatic%20atmosphere%2C%20warm%20yet%20tense%20lighting%2C%20family%20dynamics%2C%20clean%20composition&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '韩国顶级财阀家族的内斗大戏。权力、金钱、亲情在一场突如其来的遗产争夺战中激烈碰撞。每个人都有自己的算盘，每一步都暗藏杀机...',
    categories: ['drama', 'mystery'],
    tags: ['财阀', '家族', '权力', '遗产'],
    status: '已完结',
    rating: 9.3,
    views: 1350000,
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: `ch10-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: `2025-${String(Math.max(1, Math.ceil((72 - i) / 5))).padStart(2, '0')}-${String((i % 14) + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-04-30',
    createdAt: '2024-01-20',
  },
  {
    id: '11',
    slug: 'dungeon-hunter',
    title: '地下城猎人',
    author: '游戏漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20cover%20illustration%20of%20a%20hunter%20in%20a%20dungeon%20with%20monsters%2C%20dynamic%20action%20pose%2C%20dramatic%20lighting%2C%20game-like%20fantasy%20setting%2C%20clean%20composition%2C%20adventure%20vibe&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '全球各地突然出现神秘地下城，觉醒者们进入其中狩猎怪物获取资源。主角作为F级最弱猎人，在一次濒死经历中获得了独一无二的隐藏能力...',
    categories: ['action', 'fantasy'],
    tags: ['地下城', '猎人', '升级', '冒险'],
    status: '连载中',
    rating: 9.5,
    views: 1890000,
    chapters: Array.from({ length: 85 }, (_, i) => ({
      id: `ch11-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: `2026-${String(Math.max(1, Math.ceil((85 - i) / 5))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-08-05',
    createdAt: '2024-08-15',
  },
  {
    id: '12',
    slug: 'love-contract',
    title: '契约恋爱',
    author: '爱情工厂',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20romance%20cover%20illustration%20of%20a%20couple%20signing%20a%20contract%20in%20a%20modern%20office%2C%20romantic%20tension%2C%20warm%20natural%20lighting%2C%20clean%20background%2C%20professional%20yet%20intimate%20atmosphere&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '为了应付家里的催婚，两个陌生人签订了一份恋爱契约。原以为只是演戏，却在朝夕相处中不知不觉动了真情。假戏真做的甜蜜爱情故事。',
    categories: ['romance', 'drama'],
    tags: ['契约', '假戏真做', '甜宠', '都市'],
    status: '已完结',
    rating: 9.0,
    views: 920000,
    chapters: Array.from({ length: 55 }, (_, i) => ({
      id: `ch12-${i + 1}`,
      number: i + 1,
      title: `第${i + 1}话`,
      createdAt: `2025-${String(Math.max(1, Math.ceil((55 - i) / 4))).padStart(2, '0')}-${String((i % 11) + 1).padStart(2, '0')}`,
    })),
    updatedAt: '2026-07-01',
    createdAt: '2024-04-10',
  },
];

export const getComicBySlug = (slug: string): Comic | undefined => {
  return comics.find((c) => c.slug === slug);
};

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  if (categorySlug === 'all') return comics;
  return comics.filter((c) => c.categories.includes(categorySlug));
};

export const getLatestComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
};

export const getTopRatedComics = (limit: number = 10): Comic[] => {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, limit);
};

export const getPopularComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getRelatedComics = (comic: Comic, limit: number = 4): Comic[] => {
  return comics
    .filter((c) => c.id !== comic.id && c.categories.some((cat) => comic.categories.includes(cat)))
    .slice(0, limit);
};

export const getCategoryName = (slug: string): string => {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
};